module.exports = __webpack_public_path__ + "static/img/mj1.a2ae7e1b.png";